$(document).ready(function () {
	loadMyAccountPayments();
	loadAccountPaymentAlerts();

	$('.js-change-plan').on('click', function (e) {
		e.preventDefault();

		const $btn = $(this);
		const planName = $btn.data('plan-name');
		const nextBilling = $btn.data('next-billing');
		const credits = $btn.data('credits');
		const charge = parseFloat($btn.data('charge'));
		const creditsToday = $btn.data('credits-today');
		const immediate = $btn.data('immediate');
		const months = $btn.data('months');
		const type = $btn.data('type');
		const planId = $btn.data('plan-id');
		const term     = $btn.data('term') || null;
		const changeUrl = $btn.data('change-url') || '/my-account/change-plan/';

		if (term && window.currentMembershipTerm === 'rolling') {

			const $form = $('.sub-form');

			// Set action
			$form.attr('action', '/my-account/upgrade/');
			$form.find('input[name="plan_id"]').val(planId);
			$form.find('input[name="months"]').val(term);

			// Load contract as you already do...
			const contractType = term == '6month' ? '6_month' : '12_month';

			$('#sub_terms').html('<p class="loading">Loading terms...</p>');

			showLoader();


			$.get('/buy-credits/get-contract/', { type: contractType }, function (resp) {
				hideLoader();
				if (resp.status === 'success') {
					$('#sub_terms').html(resp.html);
				}
			}, 'json');

			$('body').addClass('menu-open');
			$('.modal__subscribe').addClass('open');
			return;
		}
		else {
			// Build summary text
			let summary = `You are switching to <strong>${planName}</strong> at £${$btn.data('next-billing')} every 4 weeks for ${credits == 99 ? 'unlimited' : credits} credits.`;
			let detail = '';

			if (immediate == 1) {
				detail = `You will pay <strong>£${charge.toFixed(2)}</strong> today and receive <strong>${creditsToday == 99 ? 'unlimited' : creditsToday}</strong> credits immediately.`;
			} else {
				detail = `Your changes will take effect on your next billing date.`;
			}

			$('#plan-summary').html(summary);
			$('#plan-extra-info').html(detail);
			$('#confirm-change').attr('data-plan-id', planId).attr('data-immediate', immediate);
			$('#confirm-change').attr('data-plan-id', planId).attr('data-immediate', immediate);
			$('#confirm-change').attr('data-months', planId).attr('data-months', months);
			$('#confirm-change').attr('data-change-url', changeUrl);

			$('#modal-change-plan').addClass('open');
		}
	});

	$('#cancel-change').on('click', function () {
		$('#modal-change-plan').removeClass('open');
	});

	$('#confirm-change').on('click', function () {
		const $confirmBtn = $(this);
		const $cancelBtn = $('#cancel-change');
		const planId = $confirmBtn.data('plan-id');
		const immediate = $confirmBtn.data('immediate');
		const months = $confirmBtn.data('months');
		const changeUrl = $confirmBtn.data('change-url') || '/my-account/change-plan/';

		$confirmBtn.prop('disabled', true).text('Please wait...');
		$cancelBtn.prop('disabled', true);

		$.ajax({
			url: changeUrl,
			method: 'POST',
			data: {
				plan_id: planId,
				immediate: immediate,
				months: months
			},
			success: function (res) {
				if (res.status === 'success') {
					$('#modal-change-plan').removeClass('open');

					$('#modal-dialog .heading').text('Plan Updated');
					$('#modal-dialog .text').html('<p>Your membership has been updated successfully. Your changes will take effect as described.</p>');
					$('#modal-dialog').attr('data-redirect', changeUrl === '/upgrade-now/change-plan/' ? '/my-account/' : '');
					$('#modal-dialog').addClass('open').addClass('reload-after-close');


				} else {
					$confirmBtn.prop('disabled', false).text('Change plan');
					$cancelBtn.prop('disabled', false);

					$('#plan-extra-info').find('.error').remove();
					$('#plan-extra-info').append(`<p class="error">${res.message}</p>`);
				}
			},
			error: function () {
				$confirmBtn.prop('disabled', false).text('Change plan');
				$cancelBtn.prop('disabled', false);

				$('#plan-extra-info').find('.error').remove();
				$('#plan-extra-info').append(`<p class="error">Something went wrong. Please try again.</p>`);
			}
		});
	});
});

function loadOverdueInvoiceBanner() {
	const $banner = $('#overdue-invoice-banner');
	if (!$banner.length) {
		return;
	}

	const url = $banner.data('url');
	if (!url) {
		return;
	}

	$.ajax({
		url: url,
		method: 'GET',
		dataType: 'json',
		success: function (resp) {
			if (!resp || resp.status !== 'success' || !resp.data || resp.data.show !== true || !resp.data.banner) {
				return;
			}

			const banner = resp.data.banner;
			const amountText = banner.amount ? ` for £${escapeHtml(banner.amount)}` : '';
			const dateText = banner.date ? ` on ${escapeHtml(banner.date)}` : '';
			const urlText = escapeAttribute(banner.url || '');

			if (!urlText) {
				return;
			}

			$banner.html(`
				<div class="container">
					<p>
						<strong>A payment has failed${amountText}${dateText}.</strong>
						Please <a href="${urlText}" target="_blank" rel="noopener noreferrer">pay it now</a>.
					</p>
				</div>
			`);
			$banner.prop('hidden', false);
		}
	});
}


function loadMyAccountPayments() {
	const $wrapper = $('#my-account-payments');
	if (!$wrapper.length) {
		return;
	}

	const url = $wrapper.data('url');
	if (!url) {
		return;
	}

	$wrapper.html('<p class="loading">Loading your payments...</p>');

	$.ajax({
		url: url,
		method: 'GET',
		dataType: 'json',
		success: function (resp) {
			if (!resp || resp.status !== 'success') {
				$wrapper.html('<p class="text-red">We could not load your payments right now. Please try again shortly.</p>');
				return;
			}

			const payments = resp.data && Array.isArray(resp.data.payments) ? resp.data.payments : [];
			if (!payments.length) {
				$wrapper.html('<p>No recent payments found.</p>');
				return;
			}

			const rows = payments.map(function (payment) {
				const status = String(payment.status || '');
				const statusText = status.toLowerCase() === 'open' ? 'Unpaid' : escapeHtml(status);
				const statusClass = status.toLowerCase() === 'open' ? ' class="status--unpaid"' : '';
				const amount = escapeHtml(payment.amount || '0.00');
				const type = escapeHtml(payment.type || '');
				const details = escapeHtml(payment.description || '');
				const date = escapeHtml(payment.date || '');
				const actionHtml = buildPaymentAction(payment);

				return `
					<tr>
						<td>${date}</td>
						<td>${type}</td>
						<td>${details}</td>
						<td>£${amount}</td>
						<td${statusClass}>${statusText}</td>
						<td class="text-right">${actionHtml}</td>
					</tr>
				`;
			}).join('');

			$wrapper.html(`
				<table class="table">
					<thead>
						<tr>
							<th>Date</th>
							<th>Type</th>
							<th>Details</th>
							<th>Amount</th>
							<th>Status</th>
							<th class="text-right">Invoice / Receipt</th>
						</tr>
					</thead>
					<tbody>${rows}</tbody>
				</table>
			`);
		},
		error: function () {
			$wrapper.html('<p class="text-red">We could not load your payments right now. Please try again shortly.</p>');
		}
	});
}

function buildPaymentAction(payment) {
	const invoiceUrl = payment.invoice_url || '';
	const receiptUrl = payment.receipt_url || '';
	const actionLabel = escapeHtml(payment.action_label || 'View Receipt');
	const status = String(payment.status || '').toLowerCase();

	if (status === 'open' && invoiceUrl) {
		return `<a href="${escapeAttribute(invoiceUrl)}" class="button button--red" target="_blank">Pay Invoice Now</a>`;
	}

	if (invoiceUrl) {
		return `<a href="${escapeAttribute(invoiceUrl)}" class="button button--white" target="_blank">View Invoice</a>`;
	}

	if (receiptUrl) {
		return `<a href="${escapeAttribute(receiptUrl)}" class="button button--white" target="_blank">${actionLabel}</a>`;
	}

	return '-';
}

function escapeHtml(value) {
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
}

function escapeAttribute(value) {
	return escapeHtml(value);
}


$('.contract-accordion__toggle').on('click', function () {
	$(this).closest('.contract-accordion').toggleClass('is-open');
});

function loadAccountPaymentAlerts() {
    const banner = document.getElementById('account-payment-alerts');
    if (!banner) return;
    const notices = document.getElementById('payment-notifications');
    const endpoint = banner.dataset.url + (notices ? '?refresh=1' : '');
    $.ajax({url:endpoint,method:'GET',dataType:'json',success:function(response) {
        if (!response || response.status !== 'success' || !response.data || !Array.isArray(response.data.alerts)) {
            if (notices) { notices.hidden = false; notices.textContent = 'We could not check your payment notifications right now. You can still manage payment methods below.'; }
            return;
        }
        const alerts = response.data.alerts;
        if (!alerts.length) return;
        banner.hidden = false;
        document.getElementById('account-payment-badge').hidden = false;
        document.getElementById('account-navigation').setAttribute('aria-label','Account — payment action required');
        document.getElementById('account-payment-summary').textContent = alerts.length === 1 ? alerts[0].title : alerts.length + ' payment notifications';
        if (!notices) return;
        notices.hidden = false;
        notices.replaceChildren();
        alerts.forEach(function (alert) {
            const item = document.createElement('section'); item.className = 'account-payment-notice';
            const title = document.createElement('h3'); title.textContent = alert.title;
            const message = document.createElement('p'); message.textContent = alert.message;
            const link = document.createElement('a'); link.className = 'button button--white'; link.textContent = alert.action;
            // Only our own portal route or HTTPS Stripe-hosted invoice links are accepted.
            let url;
            try { url = new URL(alert.url, window.location.origin); } catch (_) { return; }
            if (url.origin !== window.location.origin && (url.protocol !== 'https:' || !['invoice.stripe.com','pay.stripe.com','billing.stripe.com'].includes(url.hostname))) return;
            link.href = url.href;
            item.append(title,message,link); notices.append(item);
        });
    }});
}
